import { useCallback } from 'react';
import {
  bridge,
  convertDeeplinkToWebLink,
  getWebBaseURL,
} from 'shared/src/utils';
import { ABLY_INFO } from 'shared/src/constant/ablyInfo';

export const useOnPressAwardDeeplink = () => {
  return useCallback<(deeplink: string) => void>(deeplink => {
    bridge.openDeeplink(deeplink, {
      webCallback: async () => {
        const baseURL = await getWebBaseURL();
        const convertedLink = convertDeeplinkToWebLink(deeplink);
        if (convertedLink === ABLY_INFO.url) {
          location.href = ABLY_INFO.url;
          return;
        }
        location.href = `${baseURL}${convertedLink}`;
      },
    });
  }, []);
};
